/**
 * Popular languages for article-to-post generation (frontend).
 * Curated list of most commonly used languages to keep UI simple.
 * Backend supports additional languages - see server/src/constants/languages.ts
 */
export const POPULAR_LANGUAGES = [
  { value: "auto", label: "Auto (Same as source)" },
  { value: "English", label: "English" },
  { value: "Spanish", label: "Spanish (Español)" },
  { value: "French", label: "French (Français)" },
  { value: "German", label: "German (Deutsch)" },
  { value: "Italian", label: "Italian (Italiano)" },
  { value: "Portuguese", label: "Portuguese (Português)" },
  { value: "Chinese", label: "Chinese (中文)" },
  { value: "Japanese", label: "Japanese (日本語)" },
  { value: "Korean", label: "Korean (한국어)" },
  { value: "Russian", label: "Russian (Русский)" },
  { value: "Hindi", label: "Hindi (हिन्दी)" },
  { value: "Turkish", label: "Turkish (Türkçe)" },
  { value: "Dutch", label: "Dutch (Nederlands)" },
  { value: "Polish", label: "Polish (Polski)" },
  { value: "Swedish", label: "Swedish (Svenska)" },
  { value: "Romanian", label: "Romanian (Română)" },
] as const;
